<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动类型名称">
            <a-input v-model="typeName"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动类型描述" v-if=showDesc>
            <a-input v-model="typeDesc"/>
          </a-form-item>

        </a-col>
      </a-row>
    </a-form>
    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="save()">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";

//接口API
import {dataApi} from '@/services/activityManage/activityType';

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    groupName: {
      rules: [{required: true, whitespace: true, message: "请输入标签分组名称"}]
    },
  };
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity() {
  this.show = true
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save() {
  console.log('this=======================================================')
  console.log(this)
  let result = {
    typeName: this.typeName,
    typeDesc: this.typeDesc
  }
  if (!this.typeName) {
    this.$message.error('请输入活动类型名称');
    return false;
  }
  if (this.showDesc&&!this.typeDesc && this.parentId) {
    this.$message.error('请输入活动类型描述');
    return false;
  }
  this.loading(true);
  let entity = {};
  if (this.readyTodo) { //准备好更新
    result.typeId = this.typeId;
    result.parentId = this.parentId

    entity = await dataApi.saveActTypeDetail(result, true); //更新
    this.showDesc=false
  } else {
    result.parentTypeId = this.parentId
    entity = await dataApi.saveActTypeDetail(result); //新增
    this.showDesc=false

    console.log('parentId==========================================='+this.parentId)

  }
  if (entity.code === 200) {
    this.$emit('cancelled');
  } else if (entity.code === 201) {
    this.$message.warn(entity.data);
  }
  this.$emit('reload');
  this.loading(false);
  location.reload()
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['selectedObj', 'readyTodo','row','parentId','typeId','showDesc'],
  inject:['reload'],
  data() {
    return {
      show: false,
      typeName: '',
      typeDesc: '',
      groupName: '',
    }
  },
  mounted() {
    if (this.readyTodo) {
      this.typeName = this.row.typeName;
      this.typeDesc = this.row.typeDesc;

    }
    console.log('row========================================='+this.row)
    console.log(this.row)
    console.log('parentId========================================='+this.parentId)
    console.log(this.parentId)
  },
  methods: {
    loadEntity,
    save,
    getRulesTemplate,
  },
};
</script>

<style scoped lang="less">
</style>
